import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser'
import { CommonModule } from '@angular/common';
// import { AgmCoreModule } from '@agm/core'; // Commented out - not compatible with Angular 15
import { routing } from './app.routing';
import { AppConfig } from './app.config';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { ErrorComponent } from './pages/error/error.component';
import { StorageServiceModule, SESSION_STORAGE, StorageService } from 'angular-webstorage-service';
import { GridModule } from '@progress/kendo-angular-grid';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { NgxSpinnerModule } from "ngx-spinner";  
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MyHttpInterceptor } from './httpinte';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { UserSessionContex } from './UserSessionContex';
//import { ToastrModule } from 'ngx-toastr';

import { NotifierModule, NotifierOptions } from 'angular-notifier';


@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    ],
    exports: [
        NotifierModule,
        BrowserModule,
        BrowserAnimationsModule,
        //ToastrModule
    ],
  imports: [
      //ToastrModule.forRoot(),
      NotifierModule.withConfig({
          position: {
              horizontal: { position: 'right', distance: 20 },
              vertical: { position: 'bottom', distance: 20, gap: 10 }
          },
          theme: 'material',
          behaviour: {
              autoHide: 5000,
              onClick: 'hide',
              showDismissButton: true
          }
      }),
      FormsModule,
      // StorageServiceModule, // Removed - not Ivy compatible, using StorageService directly via SESSION_STORAGE injection
      BrowserModule,
      NgxSpinnerModule,
      CommonModule,
      GridModule,
      HttpClientModule,
      BrowserAnimationsModule,
      // AgmCoreModule.forRoot({
      //   apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE'
      // }), // Commented out - not compatible with Angular 15
    routing,
    ToolBarModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
    providers:
        [
            AppConfig,
            UserSessionContex,
            {
                provide: SESSION_STORAGE,
                useFactory: () => {
                    // Create a wrapper around native sessionStorage that implements the StorageService interface
                    return {
                        get: (key: string) => {
                            const item = sessionStorage.getItem(key);
                            try {
                                return item ? JSON.parse(item) : null;
                            } catch {
                                return item;
                            }
                        },
                        set: (key: string, value: any) => {
                            sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
                        },
                        remove: (key: string) => {
                            sessionStorage.removeItem(key);
                        },
                        clear: () => {
                            sessionStorage.clear();
                        }
                    };
                }
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: MyHttpInterceptor,
                multi: true,
            }
        ],
  bootstrap: [AppComponent]
})
export class AppModule { }
